<template>
  <div class="AddText" :class="className">
    <div class="AddText-Edit">
      <Vueditor ref="editor"></Vueditor>
    </div>
  </div>
</template>

<script>
import { customizeEditor } from "@/plugins/vueditor";

export default {
  props: {
    className: {
      type: String,
      required: false
    },
    value: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      editorUnsubscribe: null,
      lastText: null
    };
  },

  watch: {
    value: function(val) {
      this.$refs.editor.setContent(val);
    }
  },
  methods: {
    focus: function() {
      this.$refs.editor.focus();
    }
  },

  mounted: function() {
    this.$refs.editor.setContent(this.value);
    this.editorUnsubscribe = this.$refs.editor.$store.subscribe(
      (mutation, state) => {
        if (
          mutation.type === "UPDATE_CONTENT" &&
          this.lastText !== state.content
        ) {
          // prevent double sending event (vueditor for some reason fires two UPDATE_CONTENT event)
          this.lastText = state.content;
          this.$emit("input", state.content);
        }
      }
    );

    customizeEditor(this.$refs.editor, this.$store);
  },
  beforeDestroy: function() {
    if (this.editorUnsubscribe) this.editorUnsubscribe();
  }
};
</script>

<style lang="scss">
.AddText {
  &-Edit {
    padding: 27px 10px 95px 10px;
    background-color: var(--color-layout-primary);
    border-radius: 20px;

    @media (max-width: $screen-mobile) {
      padding: 15px 10px 50px 10px;
    }
  }
}
</style>
